import styled from "styled-components";
import Colors from "../../themes/Colors";

export const FooterContainer = styled.footer`
  background-color: ${(props) => props?.footerBgColor || Colors.white};
  padding: 16px;
  margin-top: 100px;
  position: ${(props) => props?.footerPosition || "fixed"};
  bottom: 0;
  left: 0;
  width: ${(props) => props?.footerWidth || "100%"};
  height: ${(props) => props.height || "30px"};
  @media screen and (max-width: 844px) {
    position: relative;
  }
`;

export const TextContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-left: ${(props) => props?.marginLeft || "auto"};
`;

export const SecondTextContainer = styled.div`
  margin-left: ${(props) => props?.marginLeft || "auto"};
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const Icon = styled.a`
  margin-right: 10px;
  color: #333;
  font-size: 16px;
  text-decoration: none;

  &:last-child {
    margin-right: 0;
  }
`;

export const FooterStyles = {
  liSocialIcon: {
    marginLeft: 10,
    width: 25,
    height: 25,
    alignSelf: "center",
    borderRadius: 25 / 2,
  },
  imgSocialIcon: {
    width: 20,
    height: 20,
    justifyContent: "center",
    marginLeft: 5,
    marginBottom: 2,
  },
  iconComment: {
    color: Colors.white,
    alignSelf: "center",
  },
  chatText: {
    color: Colors.white,
    fontSize: 14,
    textAlign: "center",
  },
};